/**
 * 실제 로컬 타임존(KST 등)의 시간을 UTC 오프셋(Z)이 포함된 ISO 문자열로 전달받은 경우,
 * 타임존의 오차를 보정하여 올바른 Date 객체를 반환합니다.
 *
 * @param isoString - ISO 8601 형식의 날짜 문자열
 * @returns 타임존 오프셋이 조정된 Date 객체
 */
export const convertUTCDate = (isoString: string | null | undefined): Date => {
  if (!isoString) {
    return new Date();
  }
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return new Date();
  }
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};
